import { render } from "./NotificationItem.vue?vue&type=template&id=06f0ad62&scoped=true&ts=true"
import script from "./NotificationItem.vue?vue&type=script&lang=ts"
export * from "./NotificationItem.vue?vue&type=script&lang=ts"

import "./NotificationItem.vue?vue&type=style&index=0&id=06f0ad62&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f0ad62"]])

export default __exports__